module.exports = "./img/1825636464e9f702afe35e13aacbe273.jpg";